import { Grid, Typography } from "@mui/material";
import styled, { css } from "styled-components";

export const SummaryContainer = styled.div`
    padding-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const ItemWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-self: center;
    padding-right: 5px;
`;

export const SummaryItemContainer = styled(Grid)`
    text-align: center;
`;

export const SummaryNumber = styled(Typography)`
    && {
        font-weight: 500;
        margin-left: 10px;
    }
`;

export const SummaryText = styled(Typography)`
    && {
        margin-top: 10px;
        font-weight: 400;
        line-height: 24px;
    }
`;

interface StyledGrid {
    $variant?: "default" | "dashboard";
}

export const StyledGrid = styled(Grid)<StyledGrid>`
    && {
        ${({ $variant = "default" }) =>
            $variant === "dashboard" &&
            css`
                margin-bottom: 20px;
            `}
    }
`;
